import styled from 'styled-components';
import Carousel from 'react-bootstrap/Carousel';

export const ContCarousel = styled(Carousel)`
  padding: 0rem 0 1rem 0;

  .carousel-indicators {
    z-index: 1;
  }
  @media (min-width: 1024px) {
    display: none;
  }

  @media (max-width: 1024px) {
    .carousel-control-next,
    .carousel-control-prev {
      position: absolute;
      top: -20%;
      bottom: 0;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15%;
      color: #fff;
      text-align: center;
      opacity: 0.5;
      transition: opacity 0.15s ease;
    }

    .carousel-indicators {
      z-index: 1;
      top: 80rem;
    }

    .carousel-indicators .active {
      background-color: #fff;
    }

    .carousel-indicators li {
      background-color: #fff;
      width: 40px;
      height: 12px;
      margin: 0 4px;
    }
  }

  @media (max-width: 900px) {
    .carousel-indicators {
      top: 55rem;
    }
  }

  @media (max-width: 700px) {
    .carousel-indicators {
      top: 47rem;
    }
  }

  @media (max-width: 600px) {
    .carousel-indicators {
      top: 46rem;
    }
  }

  @media (max-width: 520px) {
    .carousel-indicators {
      top: 33rem;
    }
  }

  @media (max-width: 380px) {
    .carousel-indicators {
      top: 33.2rem;
    }
  }
`;

export const CarouselItem = styled(Carousel.Item)`
  padding: ${(props) => (props.isLoading ? '2rem 8rem' : '10rem 5rem')};
  padding-left: 7rem;
  min-height: 40vh;
  background-size: cover;
  // background-image: url(${(props) => props.src});
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;

  @media (min-width: 1024px) {
    display: none;
  }

  @media (max-width: 1024px) {
    min-height: 750px;
    padding-left: 0;
    background-position: left;
  }

  @media (max-width: 900px) {
    margin-top: 4rem;
    min-height: 500px;
    img {
      min-height: 500px !important;
    }
  }

  @media (max-width: 750px) {
    margin-top: 4rem;
    min-height: 430px;
    img {
      min-height: 430px !important;
    }
  }

  @media (max-width: 500px) {
    margin-top: 4rem;
    min-height: 400px;
    img {
      min-height: 400px !important;
    }
  }

  @media (max-width: 450px) {
    margin-top: 4rem;
    min-height: 300px;
    img {
      min-height: 300px !important;
    }
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-height: 38rem;
    min-height: 750px;
  }

  .imgCarousel img {
    position: aboslute;
    box-shadow: 0px 10px 20px 5px #bdc3c7;
  }

  .options-container {
    position: absolute;
    z-index: 7;
    top: 7rem;
    left: 1.6rem;
    width: 25rem;
    border-bottom-left-radius: 3rem;
    border-bottom-right-radius: 3rem;
    background-color: ${(props) => props.backgroundoption};
    overflow: hidden;
  }

  .option {
    font-size: 1.8rem;
    text-align: center;
    font-weight: 700;
    padding: 0.5rem 1rem;
    border-bottom: 1px solid #fff;
    cursor: pointer;
    color: ${(props) => props.colorprincipal};
  }

  .contact-btn {
    display: flex !important;
    align-items: center !important;
    justify-align: center !important;
    gap: 10px;
    overflow: hidden;
    padding: 0.3rem 2rem;
    cursor: pointer;
    color: ${(props) => props.colorprincipal};
    width: 100%;
    font-weight: 700;
    transition: all 0.3s;

    p{
      text-align: center !important;
      width: 100%;
    }

    &:hover {
      filter: brightness(1.1);
      letter-spacing: 1px;
    }

  // @media (max-width: 520px) {
  //   img {
  //     position: absolute;
  //     top: 0;
  //     left: 0;
  //     width: 100%;
  //     max-height: 35rem;
  //     min-height: 30rem;
  //   }
  // }
`;

export const InfoMobile = styled.div`
  position: relative;
  margin-top: 31rem !important;
  padding-left: 5rem;
  padding-bottom: 0rem;
  z-index: 3;

  h1 {
    font-size: ${(props) => 40 * props.fontSizeMultiplier} !important;
    font-weight: bold !important;
    color: ${(props) => props.color};
  }

  h3 {
    font-size: ${(props) => 18 * props.fontSizeMultiplier};
    letter-spacing: 2px;
    font-weight: 400;
  }

  p {
    font-size: ${(props) => 18 * props.fontSizeMultiplier} !important;
  }

  .imgInfoPuntos {
    width: 16% !important;
  }

  @media (min-width: 1024px) {
    display: none;
  }

  @media (max-width: 520px) {
    margin-top: 22rem;
    padding-left: 6rem;

    h3 {
      font-size: ${(props) => 16 * props.fontSizeMultiplier};
    }

    h1 {
      font-size: ${(props) => 35 * props.fontSizeMultiplier} !important;
      font-weight: bold !important;
    }

    .imgInfoPuntos {
      width: 30%;
    }
  }

  @media (max-width: 900px) {
    margin-top: 45rem !important;
    // padding-left: 5rem;
  }

  @media (max-width: 750px) {
    margin-top: 36rem !important;
  }

  @media (max-width: 450px) {
    margin-top: 23rem !important;
  }
`;

export const Span = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  background-color: #fff;

  @media (max-width: 520px) {
    width: 40px;
    height: 40px;

    img {
      width: 90%;
    }
  }
`;

export const SelectButton = styled.div`
  background-color: ${(props) =>
    props.buttonSelected === false
      ? props.theme.azulPpal
      : props.theme.azulVerde};
  color: #fff;
  border: 1px solid;
  min-width: 25rem;
  width: 25rem;
  max-width: 25rem;
  height: 7rem;
  padding: 1rem 0.2rem;
  margin-right: 1rem;
  margin-bottom: 1rem;

  border-radius: ${(props) =>
    props.buttonSelected === false ? '40px;' : '40px 40px 0 0;'};
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;

  .cont-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
  }

  h2 {
    margin: 0 0 0 1rem;
    font-size: 1.5rem;
    color: #fff;
    justify-self: flex-start;
  }
`;

export const BtnPeticiones = styled.button`
  border-style: none;
  box-shadow: 0px 0px 6px #00000029;
  padding: 2rem 2rem;
  min-width: 25rem;
  width: 25rem;
  max-width: 25rem;
  height: 7rem;
  border-radius: 100px;
  font-weight: bold;
  font-size: 1.5rem;
  color: ${(props) => props.color};
  background-color: ${(props) => props.background};
`;

// Estilos del menu flotante del carousel ubicado abajo a la izquierda
export const ContMenuFlotanteCarousel = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px 0;
  position: absolute;
  margin-left: 12rem;
  width: 80%;
  padding: 0;
  bottom: 0px;
  z-index: 0;

  @media (min-width: 1024px) {
    display: none;
  }

  @media (max-width: 600px) {
    margin-left: 2rem;
  }

  .cont-item-menu-flotante {
    position: relative;
    display: flex !important;
    align-items: center;
    max-width: 100px;
    width: 33%;
    min-width: 50px;
    flex-wrap: wrap;
    height: 100px !important;
    font-size: 10px;
    z-index: 1;
    padding: 0rem 0.7rem 2rem 0.7rem;
    background-color: ${(props) => props.background};
    border-radius: 50% 50% 0 0;
    transition: 0.3s all;
    box-shadow: 0px 0px 6px #00000029;
  }
`;

export const ContMenuLinks = styled.div`
  /* outline: 1px solid red; */
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px 0;
  position: absolute;
  margin-left: 12rem;
  width: 80%;
  padding: 0;
  bottom: 0px;
  z-index: 5;

  @media (min-width: 1024px) {
    display: none;
  }

  @media (max-width: 600px) {
    margin-left: 2rem;
  }

  .cont-item-menu-flotante {
    position: relative;
    display: flex !important;
    align-items: center;
    max-width: 100px;
    width: 33%;
    min-width: 50px;
    flex-wrap: wrap;
    height: 100px !important;
    font-size: 10px;
    z-index: 1;
    padding: 0rem 0.7rem 2rem 0.7rem;
    background-color: transparent;
    border-radius: 50% 50% 0 0;
    transition: 0.1s all;

    .aLink {
      text-align: center;
      padding: 3rem 0.7rem 4rem 0.7rem;
      position: absolute;
      cursor: pointer;
      transition: 0.2s all;

      &:hover {
        filter: brightness(1.1);
        padding: 0.5rem 0.7rem 4rem 0.7rem;
        color: ${(props) => props.color};
      }

      a {
        font-weight: bold !important;
        font-size: ${(props) => 10 * props.fontSizeMultiplier} !important;
        color: ${(props) => props.color};
        transition: 0.3s all;
      }
    }
  }
`;

export const Svg = styled.svg`
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: -6%;
  width: 100%;
`;

export const ContMenuLinksTwo = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px 0;
  position: relative;
  margin-top: 0.5rem;
  width: 100%;
  padding: 0;
  bottom: 0px;
  z-index: 1;

  @media (min-width: 1024px) {
    display: none;
  }

  .cont-item-menu-flotante {
    .cont-img {
      position: relative;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      max-width: 80px;
      min-width: 80px;
      flex-wrap: wrap;
      height: 80px !important;
      z-index: 1;
      background-color: #808080;
      border-radius: 50%;
      transition: 0.1s all;
      margin-top: 2rem;

      .imgIcon {
        width: 70%;
        position: relative !important;
        max-height: 5rem !important;
        min-height: 5rem !important;
      }

      &:hover {
        filter: brightness(1.1);
      }
    }

    .aLink {
      display: flex !important;
      justify-content: center;
      align-items: center;
      text-align: center;
      max-width: 80px;
      min-width: 80px;

      padding: 2rem 0.7rem 4rem 0.7rem;
      position: absolute;
      cursor: pointer;
      transition: 0.2s all;
      padding: 0.7rem 0.2rem;

      &:hover {
        filter: brightness(1.1);
        padding: 0.5rem 0.7rem 4rem 0.7rem;
        color: #156dbc;
      }

      a {
        font-weight: bold !important;
        // font-size: ${(props) => 8 * props.fontSizeMultiplier} !important;
        font-size: 10px;
        color: ${(props) => props.color};
        transition: 0.3s all;
      }
    }
  }
`;
